import { Grid } from '@mui/material';

import Reports from './Reports';
import CheckList from './CheckList';

const ReturnedDocs = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Reports />
      </Grid>
      <Grid item xs={6}>
        <CheckList />
      </Grid>
    </Grid>
  );
};

export default ReturnedDocs;
